import { initState } from './index';

export default {
  reset(state) {
    Object.assign(state, initState());
  },
  setError(state, error) {
    state.error = error;
  },
  setLoading(state, payload) {
    state.isLoading = payload;
  },
  setAdding(state, payload) {
    state.isAdding = payload;
  },
  setEffects(state, payload) {
    state.effects = payload;
  },
  setSar(state, payload) {
    state.sar = payload;
  },
  setTypes(state, payload) {
    state.types = payload;
  },
  addUsers(state, payload) {
    state.users.push(...payload);
  },
  setUsers(state, payload) {
    state.users = payload;
  },
  setPaging(state, payload) {
    state.paging = payload;
  },
};
